export default __webpack_public_path__ + "static/ex5-signature-7796bc57f98deb9c36368ed124728e3b.webp";